import { createSlice } from "@reduxjs/toolkit";
import {
  DataDetalleReporte,
  DataHistorial,
  DataSolicitudReportes,
  DataMotivos,
  SolicitudObtenerReportes,
} from "interfaces/reportes/reportesInterface";

interface ReportesInterface {
  lstMotivos: DataMotivos[];
  lstReportes: DataSolicitudReportes[];
  consultaReporte: SolicitudObtenerReportes | null;
  reporteSelected: any;
  detalleReporte: DataDetalleReporte | null;
  historialReporte: DataHistorial | null;
  successSaveReporte: boolean;
}

const initialState: ReportesInterface = {
  lstMotivos: [],
  lstReportes: [],
  consultaReporte: null,
  reporteSelected: null,
  detalleReporte: null,
  historialReporte: null,
  successSaveReporte: false,
};

export const reportesSilce = createSlice({
  name: "auth",
  initialState,
  reducers: {
    onResetReporteSelected: (state) => {
      state.reporteSelected = null;
    },
    onLoadMotivos: (state, { payload }) => {
      state.lstMotivos = payload;
    },
    onLoadLstReportes: (state, { payload }) => {
      state.lstReportes = payload;
    },
    onLoadDataReporte: (state, { payload }) => {
      state.consultaReporte = payload;
    },
    onLoadDetalleReporte: (state, { payload }) => {
      state.detalleReporte = payload;
    },
    onLoadHistorialReporte: (state, { payload }) => {
      state.historialReporte = payload;
    },
    onLoadReporteSeleccionado: (state, { payload }) => {
      state.reporteSelected = payload;
    },
    onSuccessSaveReporte: (state, { payload }) => {
      state.successSaveReporte = payload;
    },
    onResetAll: (state) => {
      state.lstMotivos = [];
      state.lstReportes = [];
      state.consultaReporte = null;
      state.reporteSelected = null;
      state.detalleReporte = null;
      state.historialReporte = null;
      state.successSaveReporte = false;
    },
  },
});

//actions creators are generated for each case reducer function
export const {
  onLoadMotivos,
  onLoadLstReportes,
  onLoadDataReporte,
  onLoadDetalleReporte,
  onResetReporteSelected,
  onLoadHistorialReporte,
  onLoadReporteSeleccionado,
  onSuccessSaveReporte,
  onResetAll,
} = reportesSilce.actions;
